import { Component, EventEmitter, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { DwButtonCommand, DwButtonConfig, DwMediaRepositoryService, DwModalConfig, DwModalHandler, 
         DwModalResult, DwConfigServiceToken, DwConfigService, DwEventService,
         DwOrmDataService, DwMessage, DwMessageSeverity} from '@devwareapps/devware-cap';
import { Observable, of, Subject, throwError } from 'rxjs';
import { map, merge, mergeMap, catchError, distinctUntilChanged, debounceTime } from "rxjs/operators";
import { PurchaseCourseModalConfig } from '../../models/purchase-course-modal-config.model';
import { PaymentsPricingRepositoryService } from '../../services/payments-pricing-repository.service';
import { CoursePriceRequest } from '../../models/course-price-request.model';
import { CoursePriceResult } from '../../models/course-price-result.model';
import { AdhocPurchaseResult } from '../../models/adhoc-purchase-result.model';
import { CourseRepositoryService } from '../../../courses/services/course-repository.service';
import { CourseEntity, AppMetaDataItemNames, CoursePurchaseEntity, CoursePurchaseStudentEntity, AppMetaData, PaymentMethodEntity } from '../../../../meta-data/app-meta-data.service';
import { HttpClient } from "@angular/common/http";
import { AddNewCard, StudentPurchaseCourseComponent } from '../student-purchase-course/student-purchase-course.component'
import { PaymentsRepositoryService } from "src/app/features/payments/services/payments-repository.service";
import { DiscountView } from '../discount-code/discount-code.component';

import { AdminManagerService } from '../../../../features/admin/services/admin-manager.service';

@Component({
  selector: 'app-purchase-course-modal',
  templateUrl: './purchase-course-modal.component.html',
  styleUrls: ['./purchase-course-modal.component.scss']
})
export class PurchaseCourseModalComponent implements OnInit, DwModalHandler {
  @ViewChild('courseDesc') courseDesc: ElementRef;
  @ViewChild('courseDescMobile') courseDescMobile: ElementRef;
  coursePricing: CoursePriceResult;
  course: CourseEntity;
  courseImageUrl: string;
  paymentsApi: string;
  purchasing: boolean = false;
  message: DwMessage;

  constructor(private paymentPricingRespository: PaymentsPricingRepositoryService, 
              private courseRepositoryService: CourseRepositoryService, 
              private paymentsRepoSvc: PaymentsRepositoryService,
              private dwMediaRepository: DwMediaRepositoryService,
              private adminManagerService: AdminManagerService,
              private dwEventService: DwEventService,
              private http: HttpClient,
              @Inject(DwConfigServiceToken) private configService: DwConfigService) 
              { 
                this.paymentsApi = `${configService.coreConfig.apiRoot}/aviator-online/Payments`;
              }

  modalConfig: DwModalConfig<PurchaseCourseModalConfig>;
  closeModal: EventEmitter<DwModalResult<any>>;

  discountCode: string;
  currentDiscountCode: string;
  showDiscountCode = false;

  ngOnInit(): void {
    // Use this for payments
    const productId = this.modalConfig.data.productId;

    this.getCoursePricing(this.modalConfig.data.payment?.BillingPostalCode);
    this.loadCourseInfo();
    this.watchPostalCode();
  }

  
  postalCodeSubject = new Subject<string>();

  pricingPostalCode: string;
  paymentMethodChange(paymentMethod: PaymentMethodEntity) {
     if (paymentMethod?.BillingPostalCode?.length>=5) {
      this.postalCodeSubject.next(paymentMethod.BillingPostalCode);
     }
  }

  watchPostalCode() {
    this.postalCodeSubject.pipe(distinctUntilChanged(), debounceTime(50))
      .subscribe(postalCode => {
        this.getCoursePricing(postalCode);
         this.pricingPostalCode = postalCode;

      });
  }

  applyDiscountCode(discountCode: string) {
    this.currentDiscountCode = discountCode;

    this.getCoursePricing(this.modalConfig.data.payment?.BillingPostalCode); 
 
    this.showDiscountCode = false;
  }

  clearDiscountCode() {
    this.currentDiscountCode = '';
    this.getCoursePricing(this.modalConfig.data.payment?.BillingPostalCode);
  }

  getCoursePriceRequest(postalCode: string): CoursePriceRequest{
    const pricingRequest: CoursePriceRequest = {
      CourseId: this.modalConfig.data.courseId,
      PackageId: this.modalConfig.data.packageId,
      PaymentParty: this.modalConfig.data.paymentParty,
      ProductId: this.modalConfig.data.productId,
      DiscountCode: this.currentDiscountCode,
      CalculateTax: true,
      PostalCode: postalCode
      
    };
    return pricingRequest;
  }
  getCoursePricing(postalCode: string) {
    this.paymentPricingRespository.getCoursePricing(this.getCoursePriceRequest(postalCode))
      .subscribe(pricingResult => {
        this.coursePricing = pricingResult;

        this.message = null;
        if (!this.coursePricing.TaxResult?.Success && postalCode  != null) {
          this.message = {
            messageBody: `Tax could not be calculated for this zip code`,
            severity: DwMessageSeverity.error,
            allowClose: false
          };
        }
      });
  }

  showMore: boolean = true;
  maxHeight: number = 52;
  descHeight : string = `${this.maxHeight}px`;
  maxHeightMobile: number = 32;
  descHeightMobile : string = `${this.maxHeightMobile}px`;
  updateHeight(){
    const h1 = this.courseDesc.nativeElement.clientHeight;
    const h2 = this.courseDescMobile.nativeElement.clientHeight;
    const collapsed = h1 == this.maxHeight || h2 == this.maxHeightMobile; 
    if (h1 > 0)
      this.descHeight = collapsed == false ? this.maxHeight + 'px' : undefined;
    if (h2 > 0)
      this.descHeightMobile = collapsed == false ? this.maxHeightMobile + 'px' : undefined;
    this.showMore = !collapsed;
  }
  toggleDescription(){
    this.updateHeight();
  }
  discountLinkOnly: boolean= true;
  discountViewChanged(view: DiscountView){
    this.discountLinkOnly = view == DiscountView.link;
  }
  loadCourseInfo() {
    if (!this.modalConfig.data.courseId) {
      return;
    }

    this.courseRepositoryService.getCourse(this.modalConfig.data.courseId)
      .subscribe(course => {
        this.course = course;
        //this.updateHeight();
        this.courseImageUrl = this.dwMediaRepository.getImageUrlFromMediaPath(this.course.CourseImageDwroMedia?.MediaPath);
      });
  }

  finalizeResult(result: DwModalResult, hasError: boolean, errMsg: string): DwModalResult{
    this.purchasing  = false;
    if (hasError) { 
      this.message = {
        messageBody: errMsg || 'An error occurred while processing your payment.',
        severity: DwMessageSeverity.error,
        allowClose: true
      }; 
    }
    result.cancelled = hasError;
    result.closeModal = !hasError;
    return result;
  }



  


  attemptPurchase() : Observable<DwModalResult>{
    let result = new DwModalResult();
    result.cancelled = false;

    if (!this.validatePurchse()) {
      result.cancelled = true;
      return of(result);
    }

    this.purchasing = true;
    const elements = this.modalConfig.data.elements;
    const stripe = this.modalConfig.data.stripe;
    const data: AddNewCard = {
      PaymentMethodId: this.modalConfig.data.paymentMethodId,
      ProcessorConfigId: this.modalConfig.data.payment?.ProcessorConfigId,
      MakeDefault: true,
      ClientSecret: this.modalConfig.data.payment?.ClientSecret,
      NameOnCard: this.modalConfig.data.payment?.BillingName,
      BillingEmail: this.modalConfig.data.payment?.BillingEmail,
      Nickname: this.modalConfig.data.payment?.DisplayName,
      PaymentMethod: this.modalConfig.data.payment,
    };
    return StudentPurchaseCourseComponent
            .checkForNewCard(this.modalConfig.data.type ?? 'default', data, elements, stripe, 
                             this.paymentsRepoSvc, this.http)
            .pipe(mergeMap(ncr => {
              if (ncr.error)
                return of(this.finalizeResult(result, true, ncr.error.message));

              let errorMessage: string = undefined;

              // let purchase = AppMetaData.CoursePurchase.CreateEntity();
              // purchase.PaymentPartyTypeId = PaymentParty.Student;
              // purchase.CoursePurchaseStudent = [];
              // purchase.CoursePurchaseCourse = [];

              // const user = this.adminManagerService.getAviatorUser()?.user;
              // const studentId = user?.ExtendedAttributes?.find(a => a.AttrName=='StudentId')?.AttrValue;

              // let cps = AppMetaData.CoursePurchaseStudent.CreateEntity();
              // cps.StudentId = studentId; 
              // purchase.CoursePurchaseStudent.push(cps);
              
              // let cpc = AppMetaData.CoursePurchaseCourse.CreateEntity();
              // cpc.CourseId = this.modalConfig.data.courseId;
              // purchase.CoursePurchaseCourse.push(cpc);

              // return this.paymentsRepoSvc.saveCoursePurchase(purchase)
              //           .pipe(mergeMap(cp => {
              //             debugger;
              //             return of(this.finalizeResult(result, false, errorMessage));
              //           }),
              //           catchError(errResponse=> {
              //             debugger;
              //             errorMessage = errResponse.error.detail;
              //             return of(this.finalizeResult(result, true, errorMessage));
              //           }), );
              const pricingRequest = this.getCoursePriceRequest(this.modalConfig.data.payment?.BillingPostalCode);
              const url = `${this.paymentsApi}/purchase-course`;
              return this.http.post<AdhocPurchaseResult>(url, pricingRequest)
                         .pipe(map(purchaseResult => {
                           return this.finalizeResult(result, !purchaseResult.IsSuccess, purchaseResult.ErrorMessage);
                         }));
            }));
  }

  validatePurchse(): boolean {
    const errors = [];

    if (!this.modalConfig.data.payment?.BillingName) {
      errors.push('Name on card is required');
    }
    
    if (!this.modalConfig.data.payment?.BillingPostalCode || this.modalConfig.data.payment?.BillingPostalCode.length < 5) {
      errors.push('Billing Zip Code is required');
    } else {
      if (!this.coursePricing?.TaxResult?.Success) {
        errors.push('Billing Zip Code is invalid');
      }
    }

    if (errors.length > 0) {
      this.message = {
        messageBody: errors.join(', '),
        severity: DwMessageSeverity.error,
        allowClose: true
      }
      return false;
    }

    this.message = null;

    return true;
  }

  buttonClick(buttonConfig: DwButtonConfig): Observable<DwModalResult> {
    let result = new DwModalResult();
    result.cancelled = false;

    switch (buttonConfig.command) {
      case DwButtonCommand.ok:
      case DwButtonCommand.saveAndClose:
      case DwButtonCommand.save:
        return this.attemptPurchase();
      case DwButtonCommand.cancel:
        result.closeModal = true;
        result.cancelled = true;
    }
    return of(result);
  }


}
